(() => {
  if (window.AbokProductEvents) return;

  function contextFor(element) {
    const productInfo = element?.closest?.('product-info');
    return {
      productId: productInfo?.dataset.productId || '',
      variantId: productInfo?.querySelector('input[name="id"]')?.value || '',
      path: window.location.pathname,
    };
  }

  function emit(element, name, fields = {}) {
    document.dispatchEvent(new CustomEvent('abok:product-event', {
      detail: Object.freeze({
        schemaVersion: 1,
        name,
        occurredAt: new Date().toISOString(),
        ...contextFor(element),
        ...fields,
      }),
    }));
  }

  document.addEventListener('abok:commerce-selection', (event) => {
    const detail = event.detail || {};
    emit(event.target, detail.type || 'commerce_selection', {
      stableKey: detail.stableKey || '',
      lineVariantId: detail.variantId || '',
      selected: Boolean(detail.selected),
      quantity: Number(detail.quantity || 1),
    });
  });

  document.addEventListener('click', (event) => {
    const tool = event.target.closest?.('[data-abok-product-tool]');
    if (!tool) return;
    emit(tool, 'tool_open', { action: tool.dataset.toolAction || 'link' });
  });

  document.addEventListener('abok:purchase-result', (event) => {
    const detail = event.detail || {};
    emit(event.target, 'purchase_result', {
      mode: detail.mode || 'add',
      status: detail.status || 'unknown',
      errorCode: detail.errorCode || '',
      lineVariantIds: Array.isArray(detail.lineVariantIds) ? detail.lineVariantIds.map(String) : [],
    });
  });

  window.AbokProductEvents = Object.freeze({ version: 1 });
})();
